module.exports = __webpack_public_path__ + "static/amulet_of_the_planes-4a65641ef743726f267edff78670ef13.jpeg";